export function getLabel(locations) {
  if (locations.length === 0) {
    return 'Location'
  } else if (locations.length === 1) {
    return locations.map(location => location.name)
  } else {
    return `${locations.length} locations`
  }
}
